import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="bg-gray-900 text-gray-400" data-id="element-68">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-69">
        <div className="grid md:grid-cols-4 gap-8" data-id="element-70">
          <div className="col-span-1" data-id="element-71">
            <div className="text-xl font-bold text-white mb-4" data-id="element-72">
              ApplicantPass
            </div>
            <p className="mb-4" data-id="element-73">
              The ATS built specifically for high-volume, high-quality sales
              recruiting.
            </p>
            <div className="flex space-x-4" data-id="element-74">
              <a href="https://www.linkedin.com/company/applicantpass" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="LinkedIn" data-id="element-75">
                <span className="sr-only" data-id="element-76">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-77">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-78" />
                </svg>
              </a>
              <a href="https://twitter.com/applicantpass" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors" aria-label="Twitter" data-id="element-79">
                <span className="sr-only" data-id="element-80">Twitter</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-81">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-82" />
                </svg>
              </a>
            </div>
          </div>
          <div data-id="element-83">
            <h3 className="text-white font-semibold mb-4" data-id="element-84">Product</h3>
            <ul className="space-y-2" data-id="element-85">
              <li data-id="element-86">
                <Link to="/features" className="hover:text-white transition-colors" data-id="element-87">
                  Features
                </Link>
              </li>
              <li data-id="element-88">
                <Link to="/pricing" className="hover:text-white transition-colors" data-id="element-89">
                  Pricing
                </Link>
              </li>
              <li data-id="element-90">
                <Link to="/integrations" className="hover:text-white transition-colors" data-id="element-91">
                  Integrations
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/case-studies" className="hover:text-white transition-colors" data-id="element-93">
                  Case Studies
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-94">
            <h3 className="text-white font-semibold mb-4" data-id="element-95">Resources</h3>
            <ul className="space-y-2" data-id="element-96">
              <li data-id="element-97">
                <Link to="/blog" className="hover:text-white transition-colors" data-id="element-98">
                  Blog
                </Link>
              </li>
              <li data-id="element-99">
                <Link to="/guides/sales-hiring" className="hover:text-white transition-colors" data-id="element-100">
                  Sales Hiring Guide
                </Link>
              </li>
              <li data-id="element-101">
                <Link to="/webinars" className="hover:text-white transition-colors" data-id="element-102">
                  Webinars
                </Link>
              </li>
              <li data-id="element-103">
                <Link to="/support" className="hover:text-white transition-colors" data-id="element-104">
                  Support
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-105">
            <h3 className="text-white font-semibold mb-4" data-id="element-106">Company</h3>
            <ul className="space-y-2" data-id="element-107">
              <li data-id="element-108">
                <Link to="/about" className="hover:text-white transition-colors" data-id="element-109">
                  About Us
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/careers" className="hover:text-white transition-colors" data-id="element-111">
                  Careers
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/contact" className="hover:text-white transition-colors" data-id="element-113">
                  Contact
                </Link>
              </li>
              <li data-id="element-114">
                <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-115">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-116">
                <Link to="/terms" className="hover:text-white transition-colors" data-id="element-117">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 text-sm text-center" data-id="element-118">
          <p data-id="element-119">
            &copy; {new Date().getFullYear()} ApplicantPass. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};